import type { FC } from 'react';

import {
  resolvePaletteColor,
  resolvePaletteForeground,
} from '@iconik-io/shared-lib/src/utils/color_palette';

import type { IconType } from '../../../../icons/constants';
import Icon, { ICONS } from '../../../../icons/icon';
import { DYNAMIC_ICON } from '../constants';
import type { MenuItem } from '../types';

import styles from './action_icon.module.css';

type Props = Pick<MenuItem, 'icon' | 'label' | 'iconColor'>;

const overriddenSizes: { [key in IconType]?: number } = {
  [ICONS.Tick]: 16,
};

const ActionIcon: FC<Props> = ({ icon, label, iconColor }) => {
  if (!icon) {
    return null;
  }
  if (icon === DYNAMIC_ICON) {
    if (!label) {
      return null;
    }
    const letters = label.split(' ').map((word) => word.charAt(0));
    const color = resolvePaletteColor(iconColor);
    return (
      <span
        className={color ? styles.letters_filled : styles.letters}
        style={
          color
            ? {
                '--action-icon-color': color,
                '--action-icon-foreground': resolvePaletteForeground(iconColor),
              }
            : undefined
        }
      >
        {((letters[0] || '') + (letters[1] || '')).toUpperCase()}
      </span>
    );
  }
  return (
    <div className={styles.icon_container}>
      <Icon size={overriddenSizes[icon] ?? 18} icon={icon} />
    </div>
  );
};

export default ActionIcon;
